<template>
	<div class="page-container">
		<!-- 轮播图容器 -->
		<div class="carousel-box">
			<div v-for="(item, index) in bgList" :key="item.pictureId"
				:class="['carousel-item', { 'active': currentIndex === index }]">
				<img :src="item.pictureUrl" alt="背景图" class="carousel-img" />
				<span class="carousel-title">{{item.pictureTitle||'暂无图片标题'}}</span>
			</div>
			<div class="carousel-dots flex-row-ac-je">
				<span v-for="(item, index) in bgList" :key="item.pictureId"
					:class="['dot', { 'active': currentIndex === index }]" @click="changeToIndex(index)"></span>
			</div>
		</div>
		<div class="jx-box">
			<span class="jxtj-title">案例精选</span>
			<div class="jx-list" ref="jxListRef" @scroll="handleJxScroll" v-if="jxList">
				<div class="jx-img-box" v-for="item in jxList" :key="item.articleId" @click="goDetail(item.articleId)">
					<img class="jx-img" referrerPolicy="no-referrer" :src="item.articleCover" />
					<div class="jx-img-bottom">
						<span class="jx-img-title">{{item.articleTitle}}</span>
						<!-- <div class="colloct-button">
							<img :src="require(`@/assets/arw-next.png`)"/>
						</div> -->
					</div>
				</div>
			</div>
			<div class="jx-dots-box flex-row-ac-jc">
				<div class="jx-pre flex-row-ac-jc" @click="scrollToPrevious">
					<img class="arrow-pre" src="@/assets/arw-pre.png" />
				</div>
				<div class="jx-dots flex-row-ac-jb">
					<span v-for="(item, index) in jxList.length" :key="index"
						:class="['jx-dot', { 'active': currentDotIndex === index }]" @click="scrollToDot(index)"></span>
				</div>
				<div class="jx-next flex-row-ac-jc" @click="scrollToNext">
					<img class="arrow-next" src="@/assets/arw-next.png" />
				</div>
			</div>
		</div>
		<div class="tj-box">
			<span class="jxtj-title">本周推荐</span>
			<div class="tj-list" ref="tjListRef" @scroll="handleJxScroll" v-if="tjList">
				<div class="tj-img-box" v-for="item in tjList" :key="item.articleId" @click="goDetail(item.articleId)">
					<img class="tj-img" referrerPolicy="no-referrer" :src="item.articleCover" />
					<div class="tj-img-bottom">
						<span class="tj-img-title">{{item.articleTitle}}</span>
					</div>
				</div>
			</div>
			<div class="tj-dots-box flex-row-ac-je">
				<div class="tj-pre flex-row-ac-jc" @click="scrollTjToPrevious">
					<img class="arrow-pre" src="@/assets/arw-pre.png" />
				</div>
				<!-- <div class="tj-dots flex-row-ac-jb">
					<span v-for="(item, index) in tjList.length" :key="index"
						:class="['tj-dot', { 'active': tjCurrentDotIndex === index }]"
						@click="scrollTjToDot(index)"></span>
				</div> -->
				<div class="tj-next flex-row-ac-jc" @click="scrollTjToNext">
					<img class="arrow-next" src="@/assets/arw-next.png" />
				</div>
			</div>
		</div>
		<div class="web-footer flex-col-ac-jc">
			<!-- <div class="el-login-footer"> -->
			<span class="web-info">Copyright © 2025 jamepang.com · All Rights Reserved · 备案号：浙ICP备2021032569号-3A</span>
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33060202001089"
				class="web-info-link flex-row-ac-js">
				<img src="http://learn.jamespang.cn:8086/b/mark_logo.png" />
				<span>浙公网安备 33060202001089号</span>
			</a>
			<!-- </div>
			<span class="web-info">copythat 备案信息 XXXXXXXXX</span> -->
		</div>
	</div>
</template>
<script>
	export default {
		name: "home",
		data() {
			return {
				bgList: [],
				currentIndex: 0,
				carouselTimer: null,
				jxList: [],
				tjList: [],
				currentDotIndex: 0, // 案例精选当前选中的指示器索引
				tjCurrentDotIndex: 0, // 本周推荐当前选中的指示器索引
				// visibleDotCount: 0, // 可见的指示器数量
				// itemsPerPage: 4, // 每页显示的项目数量
			}
		},
		mounted() {
			this.getBgList();
			this.getJxList();
			this.getTjList();
		},
		// watch: {
		// 	// 监听jxList变化，更新指示器数量
		// 	jxList: {
		// 		handler(newList) {
		// 			if (newList && newList.length > 0) {
		// 				this.visibleDotCount = Math.ceil(newList.length / this.itemsPerPage);
		// 			}
		// 		},
		// 		immediate: true,
		// 	},
		// 	// 监听jxList变化，更新指示器数量
		// 	tjList: {
		// 		handler(newList) {
		// 			if (newList && newList.length > 0) {
		// 				this.visibleDotCount = Math.ceil(newList.length / this.itemsPerPage);
		// 			}
		// 		},
		// 		immediate: true,
		// 	}
		// },
		// 在组件销毁前清除定时器
		beforeUnmount() {
			if (this.carouselTimer) {
				clearInterval(this.carouselTimer);
			}
		},
		methods: {
			getBgList() {
				let params = {};
				console.log("------接口请求-参数--api.getBgList");
				console.log(params);
				this.$http.getBgList(params).then((res) => {
					console.log("------接口请求-结果--api.getBgList");
					console.log(res)
					if (res && res.code === 0 && res.data) {
						this.bgList = res.data;
					} else {
						// 如果接口请求失败，使用默认的图片数组
						this.bgList = [{
							"pictureId": 1,
							"pictureUrl": "https://picsum.photos/id/1015/1728/697"
						}, {
							"pictureId": 2,
							"pictureUrl": "https://picsum.photos/id/1018/1728/697"
						}, {
							"pictureId": 3,
							"pictureUrl": "https://picsum.photos/id/1019/1728/697"
						}];
					}
					// 启动轮播
					this.startCarousel();
				}).finally(() => {});
			},
			getJxList() {
				let params = {};
				this.$http.getCaseList(params).then((res) => {
					console.log("--api getJxList--参数");
					console.log(params);
					if (res && res.code === 0 && res.data) {
						console.log("--api getJxList--结果");
						console.log(res)
						this.jxList = res.data;
					} // 如果接口请求失败或数据为空，保持默认空数组
				}).finally(() => {});
			},
			getTjList() {
				let params = {};
				this.$http.getCaseList2(params).then((res) => {
					console.log("------接口请求-结果--api getTjList");
					console.log(params);
					console.log(res)
					if (res && res.code === 0 && res.data) {
						this.tjList = res.data;
					} // 如果接口请求失败或数据为空，保持默认空数组
				}).finally(() => {});
			},
			// 启动轮播
			startCarousel() {
				// 清除之前的定时器
				if (this.carouselTimer) {
					clearInterval(this.carouselTimer);
				}
				// 设置新的定时器，每5秒切换一次图片
				this.carouselTimer = setInterval(() => {
					this.currentIndex = (this.currentIndex + 1) % this.bgList.length;
				}, 5000);
			},
			// 切换到指定索引的轮播图
			changeToIndex(index) {
				this.currentIndex = index;
				// 重新开始定时器
				this.startCarousel();
			},

			// 处理精选案例列表的滚动事件
			handleJxScroll() {
				// 判断是哪个列表触发的滚动事件
				const eventSource = event.target;
				if (eventSource === this.$refs.jxListRef) {
					// 案例精选列表的滚动处理
					const scrollLeft = this.$refs.jxListRef.scrollLeft;
					const scrollPosition = Math.round(scrollLeft / 940);
					if (scrollPosition !== this.currentDotIndex && scrollPosition >= 0 && scrollPosition < this.jxList
						.length) {
						this.currentDotIndex = scrollPosition;
					}
				} else if (eventSource === this.$refs.tjListRef) {
					// 本周推荐列表的滚动处理
					const scrollLeft = this.$refs.tjListRef.scrollLeft;
					const scrollPosition = Math.round(scrollLeft / 343);
					if (scrollPosition !== this.tjCurrentDotIndex && scrollPosition >= 0 && scrollPosition < this.tjList
						.length) {
						this.tjCurrentDotIndex = scrollPosition;
					}
				}
			},

			// 点击指示器滚动到对应位置
			scrollToDot(index) {
				// 计算正确的滚动位置：图片宽度 * 索引
				const scrollTarget = 940 * index;
				this.$refs.jxListRef.scrollTo({
					left: scrollTarget,
					behavior: 'smooth'
				});
				this.currentDotIndex = index;
			},

			// 点击上一张按钮
			scrollToPrevious() {
				// 计算上一张图片的索引
				let newIndex = this.currentDotIndex - 1;
				if (newIndex < 0) {
					newIndex = 0; // 确保不小于0
				}
				// 滚动到对应位置
				const scrollTarget = 940 * newIndex;
				this.$refs.jxListRef.scrollTo({
					left: scrollTarget,
					behavior: 'smooth'
				});
				this.currentDotIndex = newIndex;
			},

			// 点击下一张按钮
			scrollToNext() {
				// 计算下一张图片的索引
				let newIndex = this.currentDotIndex + 1;
				// 确保不超过最大索引
				if (newIndex >= this.jxList.length) {
					newIndex = this.jxList.length - 1;
				}
				// 滚动到对应位置
				const scrollTarget = 940 * newIndex;
				this.$refs.jxListRef.scrollTo({
					left: scrollTarget,
					behavior: 'smooth'
				});
				this.currentDotIndex = newIndex;
			},

			// 点击上一张按钮（本周推荐）
			scrollTjToPrevious() {
				// 计算上一张图片的索引
				let newIndex = this.tjCurrentDotIndex - 1;
				if (newIndex < 0) {
					newIndex = 0; // 确保不小于0
				}
				// 滚动到对应位置
				const scrollTarget = 343 * newIndex;
				this.$refs.tjListRef.scrollTo({
					left: scrollTarget,
					behavior: 'smooth'
				});
				this.tjCurrentDotIndex = newIndex;
			},

			// 点击下一张按钮（本周推荐）
			scrollTjToNext() {
				// 计算下一张图片的索引
				let newIndex = this.tjCurrentDotIndex + 1;
				// 确保不超过最大索引
				if (newIndex >= this.tjList.length) {
					newIndex = this.tjList.length - 1;
				}
				// 滚动到对应位置
				const scrollTarget = 343 * newIndex;
				this.$refs.tjListRef.scrollTo({
					left: scrollTarget,
					behavior: 'smooth'
				});
				this.tjCurrentDotIndex = newIndex;
			},

			goDetail(articleId) {
				this.$router.push({
					path: '/gallery/detail',
					query: {
						articleId: articleId
					}
				})
			}
		},
	};
</script>
<style lang="scss" scoped>
	.page-container {
		width: 100%;
		height: auto;
		position: relative;
		z-index: 1;
	}

	/* 轮播图样式 */
	.carousel-box {
		width: 100%;
		height: 0;
		padding-top: 40.336%;
		position: relative;

		.carousel-item {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			opacity: 0;
			transition: opacity 0.5s ease;

			&.active {
				opacity: 1;
			}

			.carousel-img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				z-index: 0;
			}

			.carousel-title {
				width: auto;
				position: absolute;
				left: 100px;
				bottom: 50px;
				z-index: 1;
				color: #FFFFFF;
				font-size: 20px;
			}
		}

		// 轮播图指示器样式
		.carousel-dots {
			position: absolute;
			bottom: 50px;
			right: 100px;
			z-index: 2;
			// padding: 10px;
			// background-color: rgba(0, 0, 0, 0.3);
			border-radius: 20px;
			gap: 8px;

			.dot {
				display: inline-block;
				width: 7px;
				height: 7px;
				border-radius: 50%;
				background-color: rgba(255, 255, 255, 0.5);
				cursor: pointer;
				transition: all 0.3s ease;

				&.active {
					width: 39px;
					border-radius: 3.5px;
					background-color: #FFFFFF;
				}

				&:hover {
					background-color: rgba(255, 255, 255, 0.8);
				}
			}
		}
	}

	.jx-box {
		width: 100%;
		height: auto;
		position: relative;

		.jx-list {
			padding: 0 300px;
			width: 100%;
			height: 410px;
			display: flex;
			gap: 30px;
			overflow-x: auto;
			scroll-behavior: smooth;

			// 隐藏滚动条但保持滚动功能
			::-webkit-scrollbar {
				display: none;
			}

			-ms-overflow-style: none;
			scrollbar-width: none;

			.jx-img-box {
				flex-shrink: 0;
				width: 940px;
				height: 400px;
				padding-bottom: 10px;
				border-radius: 8px;
				position: relative;
				cursor: pointer;

				&:hover {
					box-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
				}

				.jx-img {
					width: 940px;
					height: 400px;
					border-radius: 8px;
					object-fit: cover;
				}

				.jx-img-bottom {
					width: 940px;
					height: 60px;
					padding: 0 20px;
					position: absolute;
					bottom: 0;
					left: 0;
					right: 0;

					.jx-img-title {
						display: block;
						width: 900px;
						font-size: 24px;
						color: rgba(255, 255, 255, 0.9);
						line-height: 60px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.colloct-button {
						width: 32px;
						height: 32px;
					}
				}
			}
		}
	}

	.tj-box {
		width: 100%;
		height: auto;
		position: relative;

		.tj-list {
			padding: 0 300px;
			width: 100%;
			height: 610px;
			display: flex;
			gap: 30px;
			overflow-x: auto;
			scroll-behavior: smooth;

			// 隐藏滚动条但保持滚动功能
			::-webkit-scrollbar {
				display: none;
			}

			-ms-overflow-style: none;
			scrollbar-width: none;

			.tj-img-box {
				flex-shrink: 0;
				width: 343px;
				height: 600px;
				padding-bottom: 10px;
				border-radius: 8px;
				position: relative;
				cursor: pointer;

				&:hover {
					box-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
				}

				.tj-img {
					width: 343px;
					height: 600px;
					border-radius: 8px;
					object-fit: cover;
				}

				.tj-img-bottom {
					width: 343px;
					height: 60px;
					padding: 0 20px;
					position: absolute;
					bottom: 0;
					left: 0;
					right: 0;

					.tj-img-title {
						display: block;
						width: 303px;
						font-size: 24px;
						color: rgba(255, 255, 255, 0.9);
						line-height: 60px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}
	}

	.jxtj-title {
		padding: 0 300px;
		height: 150px;
		line-height: 150px;
		font-weight: 500;
		font-size: 32px;
		color: #000000;
	}

	.jx-dots-box,
	.tj-dots-box {
		width: 100%;
		height: 100px;
		padding: 0 200px;

		.jx-dots,
		.tj-dots {
			padding: 0 20px;
			height: 44px;
			border-radius: 22px;
			background: #EBEBF0;
			gap: 8px;

			.jx-dot,
			.tj-dot {
				display: inline-block;
				width: 6px;
				height: 6px;
				border-radius: 50%;
				background-color: #999;
				transition: all 0.3s ease;
				cursor: pointer;
				user-select: none;

				&.active {
					width: 24px;
					border-radius: 3px;
					background-color: #333;
				}

				&:hover {
					background-color: #666;
				}
			}
		}

		.jx-pre,
		.tj-pre {
			margin-right: 30px;
		}

		.jx-next,
		.tj-next {
			margin-left: 30px;
		}

		.jx-pre,
		.jx-next,
		.tj-pre,
		.tj-next {
			width: 44px;
			height: 44px;
			border-radius: 50%;
			background: #EBEBF0;
			cursor: pointer;
			user-select: none;

			.arrow-pre,
			.arrow-next {
				width: 11px;
				height: 18px;
			}
		}
	}

	.web-footer {
		width: 100%;
		height: 80px;
		background-color: #222222;

		.web-info {
			font-weight: 400;
			font-size: 14px;
			color: #666666;
		}

		.web-info-link {
			margin-top: 10px;
			font-size: 14px;
			text-decoration: none;

			img {
				margin-right: 8px;
			}

			span {
				color: #666666;
				display: block;
				height: 20px;
				line-height: 20px;
			}
		}
	}
</style>